import { z } from 'zod';

import { defineService } from '@@api/lib/defineService';
import { UrlPreview } from '@@api/services/functions/schemas';
import config from '@@config';

export const functionsService = defineService(
    (defineEndpoint) => ({
        checkIframeAllowed: defineEndpoint({
            method: 'GET',
            path: '/iframe-allowed',
            query: z.object({
                url: z.string(),
            }),
            responses: {
                200: z.object({
                    allowed: z.boolean().nullable(),
                }),
            },
        }),
        checkUrlPreview: defineEndpoint({
            method: 'GET',
            path: '/url-preview',
            query: z.object({
                url: z.string(),
            }),
            responses: {
                200: UrlPreview,
            },
        }),
    }),
    {
        baseUrl: config.apiEnvVars.functionsUrl,
    },
);
